window.summonToast = function summonToast(message, { type = 'info', duration = 5000 } = {}) {
    const toastType = `${type ?? 'default'}`;
    // Create element and attach to body
    const toast = document.createElement('div');
    toast.className = `toast ${toastType}`;
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => {
        toast.classList.add('show');
    }, 100);
    setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
            document.body.removeChild(toast);
        }, 500);
    }, duration ?? 5000);
}


window.toggleAnimation = function (element) {
    // toggle remove 
    if (element.hasAttribute('data-remove-class')) {
        let removeClasses = element.dataset.removeClass
        let remClsArr = removeClasses.split(' ');
        remClsArr.map(cl => element.classList.toggle(cl));
    }

    // toggle Active
    if (element.hasAttribute('data-add-class')) {
        let activeClasses = element.dataset.addClass
        let actClsArr = activeClasses.split(' ');
        actClsArr.map(cl => element.classList.toggle(cl));
    }
}

window.toggleContent = function (element) {
    // set content for removal 
    if (element.hasAttribute('data-remove-content')) {
        var removeContent = element.dataset.removeContent
    }

    // set content for addition 
    if (element.hasAttribute('data-add-content')) {
        var addContent = element.dataset.addContent
    }

    if (element.innerHTML == removeContent) {
        element.innerHTML = addContent
    } else if (element.innerHTML == addContent) {
        element.innerHTML = removeContent
    } else {
        console.log('Content Does not match either');
    }

}

// Siblings selector 

window.getAllSiblings = function (element, parent) {
    const children = [...parent.children];
    return children.filter(child => child !== element);
}

// resize element

window.elementHeight = function (el) {
    if (window.innerWidth < md) {
        el.style.height = window.innerHeight + 'px';
    } else {
        el.style.height = 'auto'
    }
}

// resize element end

// Match Height

window.setHeight = function (el, val) {
    if (typeof val === "function") val = val();
    if (typeof val === "string") el.style.height = val;
    else el.style.height = val + "px";
}

window.equalheight = function () {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;

    var matchHeightSelectors = Array.from(document.querySelectorAll('[data-match-height]')).map(x => x.dataset.matchHeight).filter((value, index, self) => self.indexOf(value) === index)

    matchHeightSelectors.forEach(x => {
        const selector = '[data-match-height="' + x + '"]'

        document.querySelectorAll(selector).forEach((el, i) => {

            el.style.height = "auto";
            topPosition = el.offsetTop;
            if (currentRowStart != topPosition) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    setHeight(rowDivs[currentDiv], currentTallest)
                }
                rowDivs.length = 0;
                currentRowStart = topPosition;
                currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
                rowDivs.push(el);
            } else {
                rowDivs.push(el);
                currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                setHeight(rowDivs[currentDiv], currentTallest)
            }
        })
    })
}

window.splideInit = function () {
    const splides = document.querySelectorAll('[data-splide-slider], [data-splide]')

    if (splides.length > 0) {
        Array.from(splides).forEach((el) => {
            const config = window.splideHelpers.getConfig(el);

            console.log("splide", el, config);
            const splide = window.splideHelpers.create(el, config);
            splide.mount();
            return splide;
        });
    }

}

window.promiseImageLoad = function (img) {
    return new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        if (img.complete) {
            resolve();
        }
    });
}